import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate, Link } from "react-router-dom";
import "./Sitemap.css";

function Sitemap() {
    const navigate = useNavigate();

    const sitemapSections = [
        {
            title: "Main Pages",
            links: [
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Contact Us", path: "/contact-form" },
                { name: "Privacy Policy", path: "/privacy-policy" },
                { name: "Terms & Conditions", path: "/terms-conditions" },
            ],
        },
        {
            title: "Vehicle Services",
            links: [
                { name: "Check Challans", path: "/checkChallan" },
                { name: "Vehicle Search", path: "/searchDetails" },
                { name: "Car Insurance", path: "/carInsurance" },
                { name: "Bike Insurance", path: "/bikeInsurance" },
                { name: "PUC Certificate", path: "/pucCertificate" },
                { name: "Car Service Report", path: "/carServiceReport" },
            ],
        },
        {
            title: "RTO Services",
            links: [
                { name: "Driving License Renewal", path: "/drivingLicenseRenewal" },
                { name: "DL Test Preparation", path: "/DLTest" },
                { name: "Ownership Transfer", path: "/ownershipTransfer" },
                { name: "Duplicate RC", path: "/duplicateRegistrationCertificate" },
                { name: "Bank NOC & Form 35", path: "/bankNoc" },
                { name: "HSRP Plate", path: "/highSecurityPlate" },
                { name: "Hypothecation Termination", path: "/hypothecationTermination" },
                { name: "Interstate RTO NOC", path: "/rtoNOC" },
                { name: "Vehicle NOC", path: "/vehicleNoc" },
                { name: "Vehicle Re-Registration", path: "/vehicleReRegistration" },
            ],
        },
        {
            title: "Buy & Sell",
            links: [
                { name: "Sell Your Car", path: "/sellYourCar" },
                { name: "Cash on Car", path: "/cashOnCar" },
                { name: "Cash on Bike", path: "/cashOnBike" },
                { name: "Add Your Vehicle", path: "/addYourVehicle" },
            ],
        },
        {
            title: "Loans & Finance",
            links: [
                { name: "Vehicle Loan", path: "/loan" },
                { name: "Instant Loan", path: "/loan" },
                { name: "Personal Loan", path: "/loan" },
                { name: "Refinance Loan", path: "/loan" },
            ],
        },
        {
            title: "Verification Services",
            links: [
                { name: "Aadhaar Verification", path: "/AdhaarVerification" },
                { name: "DL Verification", path: "/DLVerification" },
            ],
        },
        {
            title: "User Account",
            links: [
                { name: "Profile", path: "/profile" },
                { name: "Login", path: "/phone" },
                { name: "Become a Partner", path: "/becomePartner" },
            ],
        },
    ];

    return (
        <div className="sitemap-container">
            <Helmet>
                <title>Sitemap | VaahanBuddy - Complete Site Navigation</title>
                <meta
                    name="description"
                    content="Browse all pages and services available on VaahanBuddy. Find RTO services, vehicle insurance, loans, challan checking, and more vehicle-related services."
                />
                <meta
                    name="keywords"
                    content="VaahanBuddy sitemap, site navigation, vehicle services, RTO services, car insurance, bike insurance"
                />
                <meta property="og:title" content="Sitemap | VaahanBuddy" />
                <meta
                    property="og:description"
                    content="Complete navigation guide to all VaahanBuddy services and pages."
                />
                <meta property="og:url" content="https://rtoxpert.com/sitemap" />
            </Helmet>

            <div className="sitemap-header">
                <button className="back-button" onClick={() => navigate(-1)}>
                    <span className="back-arrow">←</span> Back
                </button>
                <h1>Sitemap</h1>
                <p className="header-subtitle">Complete Navigation Guide</p>
            </div>

            <div className="sitemap-content">
                <div className="sitemap-intro">
                    <p>
                        Welcome to the VaahanBuddy sitemap. This page provides a complete overview of all
                        pages and services available on our platform. Click on any link to navigate directly
                        to that page.
                    </p>
                </div>

                <div className="sitemap-grid">
                    {sitemapSections.map((section, index) => (
                        <div key={index} className="sitemap-section">
                            <h2>{section.title}</h2>
                            <ul>
                                {section.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <Link to={link.path}>{link.name}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="sitemap-footer-info">
                    <h2>Need Help?</h2>
                    <p>
                        If you cannot find what you're looking for, please don't hesitate to contact our
                        support team. We're here to help you with all your vehicle service needs.
                    </p>
                    <div className="sitemap-contact">
                        <p><strong>Email:</strong> hello@vaahanbuddy.com</p>
                        <p><strong>Phone:</strong> +91 95544 94415</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sitemap;
